document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const slide = document.querySelector(".l-slide");
  const mask = document.querySelector(".mask");
  const slideClose = document.querySelector(".l-slideClose");

  const openMenu = () => {
    slide.classList.add("show");
    mask.classList.add("show");
    setTimeout(() => {
      document.querySelector("main").style.display = "none";
    }, 400);
  };

  const closeMenu = () => {
    slide.classList.remove("show");
    mask.classList.remove("show");
    document.querySelector("main").style.display = "block";
  };

  const toggleMenu = (e) => {
    e.preventDefault();
    if (slide.classList.contains("show")) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // ▼ ハンバーガークリックで開閉
  document.querySelectorAll(".l-headerMenu").forEach((menu) => {
    menu.addEventListener("click", toggleMenu);
  });

  // ▼ マスククリックで閉じる
  mask?.addEventListener("click", closeMenu);

  // ▼ ×ボタンクリックで閉じる
  slideClose?.addEventListener("click", closeMenu);

  // modal関連
  const modalConfigs = [
    {
      triggers: [".l-headerLang", ".l-slideLang"],
      modal: "#modalLang",
    },
    {
      triggers: [".search-word"],
      modal: "#modalWord",
    },
    {
      triggers: [".search-item"],
      modal: "#modalItem",
      useMask: true,
    },
    {
      triggers: [".search-archive"],
      modal: "#modalArchive",
      useMask: true,
    },
  ];

  modalConfigs.forEach(({ triggers, modal, useMask }) => {
    const triggerEls = document.querySelectorAll(triggers.join(","));
    const modalEl = document.querySelector(modal);

    if (!triggerEls.length || !modalEl) return;

    const modalInner = modalEl.querySelector(".c-modalInner");
    const modalClose = modalEl.querySelector(".c-modalClose");

    const openModal = () => {
      modalEl.classList.add("show");
      if (useMask && mask) mask.classList.add("show");
    };

    const closeModal = () => {
      modalEl.classList.remove("show");
      if (useMask && mask) mask.classList.remove("show");
    };

    // 開く
    triggerEls.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        openModal();
      });
    });

    // ×で閉じる
    modalClose?.addEventListener("click", closeModal);

    // 外側クリックで閉じる
    modalEl.addEventListener("click", closeModal);

    // 中身クリックでは閉じない
    modalInner?.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });

  // GTranslate 言語切替処理
  window.gtranslateSettings = {
    default_language: "ja",
    native_language_names: true,
    languages: ["ja", "en"],
    wrapper_selector: ".gtranslate_wrapper",
  };

  // セレクトで切り替えた時にバッジも更新
  document.getElementById("gt-select").addEventListener("change", function (e) {
    const lang = e.target.value;
    if (!lang) return;

    // GTranslateのボタンをクリックして切替
    const btn = document.querySelector(`.gtranslate_wrapper [data-gt-lang="${lang}"]`);
    if (btn) btn.click();
  });
});


if (document.querySelectorAll(".startTimeArchive").length) {
  const startTimeElements = document.querySelectorAll(".startTimeArchive");
  startTimeElements.forEach((el) => {
    const startTime = new Date(el.dataset.time);
    const now = new Date();
    if (now >= startTime) {
      el.style.display = "none";
    }
  });
}
